export default __webpack_public_path__ + "static/media/tafi.6cea0130.svg";